import React from 'react';
import PropTypes from 'prop-types';
import {
  BlockStack, Button, CalloutCard, Card, InlineStack, Text,
} from '@shopify/polaris';

export const STAR_CSS = `
.star-vsk .star-partner-logo { width: 60px; height: 60px; border-radius: 50%; object-fit: cover; }
.star-vsk .star-partner-description { height: 45px; overflow-y: scroll; margin: 0; }
.star-vsk .star-app-name { color: black; }
.star-vsk .star-partner-card-container { padding: 0 1px; }
.star-vsk .star-partner-card-container .Polaris-CalloutCard__Content img { width: 170px; }
`;

const EMPTY_ILLUSTRATION = 'data:image/svg+xml;utf8,'
  + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="170" height="100">'
    + '<rect width="170" height="100" fill="#e3e3e3"/></svg>',
  );

const cardImage = (values) => values.previewImage || values.app_icon || values.logo_url;

const bannerImage = (values) => values.previewImage || values.image_url;

export const CardTile = ({ values }) => {
  const image = cardImage(values);

  return (
    <Card>
      <InlineStack align="start" gap="200" wrap={false}>
        <div>
          {image
            ? <img src={image} className="star-partner-logo" alt={values.app_name || ''} />
            : (
              <div
                className="star-partner-logo"
                style={{
                  background: 'var(--p-color-bg-fill-tertiary)',
                  display: 'grid',
                  placeItems: 'center',
                }}
              >
                <Text as="span" variant="bodySm" tone="subdued">icon</Text>
              </div>
            )}
        </div>

        <div>
          <BlockStack inlineAlign="start" align="start">
            <Text variant="headingMd" as="h2">
              <a
                href={values.offer_url || '#'}
                onClick={(e) => e.preventDefault()}
                className="star-app-name notranslate"
              >
                {values.app_name || 'App name'}
              </a>
            </Text>

            <div>
              <p className="star-partner-description">
                {values.description || 'Short description of the partner app.'}
              </p>
            </div>

            <InlineStack gap="200" wrap={false}>
              <div>
                <Button>{values.cta_text || 'Add '}</Button>
              </div>

              <BlockStack align="center" inlineAlign="end">
                <Text as="span">{values.special_offer_text}</Text>
              </BlockStack>
            </InlineStack>
          </BlockStack>
        </div>
      </InlineStack>
    </Card>
  );
};

export const BannerTile = ({ values }) => (
  <div className="star-partner-card-container">
    <CalloutCard
      title={values.title || 'Banner title'}
      illustration={bannerImage(values) || EMPTY_ILLUSTRATION}
      primaryAction={{
        content: values.cta_text || 'Learn more',
        onAction: () => { },
      }}
    >
      <p>{values.description || 'What the merchant gets, in a sentence or two.'}</p>
    </CalloutCard>
  </div>
);

CardTile.propTypes = { values: PropTypes.object.isRequired };
BannerTile.propTypes = { values: PropTypes.object.isRequired };
